import { User } from "@/types";

import { axios } from "../axios.instance";

export type RequestResetPasswordRequest = {
  email: User["email"];
};

export type RequestResetPasswordResponse = {
  waitMs: number;
  otpSentAt: string;
};

export const requestResetPassword = async (
  body: RequestResetPasswordRequest
): Promise<RequestResetPasswordResponse> => {
  const { data } = await axios.post("auth/request-reset-password", body);

  return data;
};
